import { useCallback } from "react";
import API_URL from '../../../utils/api';

export default function useDashboard({ setUser, setSessions, navigate }) {
  // Logic only, states are in the component
  const fetchUser = useCallback(async (userId) => {
    try {
      const response = await fetch(`${API_URL}/api/profile/${userId}`);
      const result = await response.json();
      if (response.ok) {
        setUser(result);
      }
    } catch {
      // Optionally handle error
    }
  }, [setUser]);
  const fetchSessions = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/api/sessions`);
      const result = await response.json();
      if (response.ok) {
        setSessions(result);
      }
    } catch {
      // Optionally handle error
    }
  }, [setSessions]);
  const handleLogout = useCallback(() => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userId");
    sessionStorage.removeItem("userId");
    navigate("/auth");
  }, [navigate]);
  const handleJoin = useCallback((id) => navigate(`/group/${id}`), [navigate]);
  return {
    fetchUser,
    fetchSessions,
    handleLogout,
    handleJoin
  };
}
